const MAX_QUANTITY = 10

type Product = {
  anuncio_id: number
  quantidade: number
}

export const checkProductQuantityExceeded = (
  products: Product[],
  idAd: number
) => {
  return products?.some(
    (element: Product) =>
      element.anuncio_id === idAd && element.quantidade >= MAX_QUANTITY
  )
}
